import { render, staticRenderFns } from "./NewMain.vue?vue&type=template&id=7dec93fb"
import script from "./NewMain.vue?vue&type=script&lang=ts"
export * from "./NewMain.vue?vue&type=script&lang=ts"
import style0 from "./NewMain.vue?vue&type=style&index=0&id=7dec93fb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports